/**
 * Метаданные источников.
 *
 * Наборы Type2X составлены самостоятельно из общеупотребительной лексики.
 * Сторонние корпуса не копировались: это исключает лицензионный риск и
 * позволяет держать состав под контролем (ТЗ §8.4).
 */

import type { CorpusSource } from './types.js';

const COMMON_CLEANING_RULES: readonly string[] = [
  'удалены персональные данные',
  'удалены дубли',
  'удалены опечатки и мусорные токены',
  'удалена нежелательная для базового курса лексика',
  'приведён единый регистр хранения (нижний)',
  'исключены слова длиннее 12 символов',
];

export const RU_SOURCE: CorpusSource = {
  id: 'type2x-ru-core',
  title: 'Type2X — базовый русский набор',
  reference: 'internal:corpora/ru',
  license: 'Собственный набор Type2X, внутреннее использование',
  importedAt: '2026-09-07',
  cleaningRules: COMMON_CLEANING_RULES,
  version: '1.1.0',
};

export const EN_SOURCE: CorpusSource = {
  id: 'type2x-en-core',
  title: 'Type2X — базовый английский набор',
  reference: 'internal:corpora/en',
  license: 'Собственный набор Type2X, внутреннее использование',
  importedAt: '2026-09-07',
  cleaningRules: COMMON_CLEANING_RULES,
  version: '1.1.0',
};

/**
 * Правила отбора предложений.
 *
 * Предложения — отдельный набор со своей лицензией и версией: они пишутся
 * иначе, чем собирается частотный список, и обновляются независимо от него.
 */
const SENTENCE_CLEANING_RULES: readonly string[] = [
  'фразы составлены самостоятельно, заимствования из сторонних текстов отсутствуют',
  'исключены персональные данные, имена, адреса и названия организаций',
  'исключены спорные и эмоционально нагруженные темы',
  'оставлены только символы, вводимые в раскладке языка',
  'сохранены заглавные буквы и знаки препинания',
  'длина ограничена одной строкой',
];

export const RU_SENTENCE_SOURCE: CorpusSource = {
  id: 'type2x-ru-sentences',
  title: 'Type2X — русские естественные предложения',
  reference: 'internal:corpora/ru/sentences',
  license: 'Собственный набор Type2X, внутреннее использование',
  importedAt: '2026-09-07',
  cleaningRules: SENTENCE_CLEANING_RULES,
  version: '1.1.0',
};

export const EN_SENTENCE_SOURCE: CorpusSource = {
  id: 'type2x-en-sentences',
  title: 'Type2X — английские естественные предложения',
  reference: 'internal:corpora/en/sentences',
  license: 'Собственный набор Type2X, внутреннее использование',
  importedAt: '2026-09-07',
  cleaningRules: SENTENCE_CLEANING_RULES,
  version: '1.1.0',
};
